import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Route, Switch, withRouter } from 'react-router-dom';
import App from './App';
import Error404 from './errors/error404';
import Trends from './trends';
import Post from './trends/post';

@withRouter
@inject('rootStore')
@observer
export default class Routes extends Component {
    render() {
        return (
            <App {...this.props}>
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={routerProps => (
                            <Trends {...this.props} {...routerProps} />
                        )}
                    />
                    <Route
                        exact
                        path="/trend/:blogPostUrlPath"
                        render={routerProps => (
                            <Post {...this.props} {...routerProps} />
                        )}
                    />
                    {/* 404 Error page */}
                    <Route
                        render={routerProps => {
                            if (routerProps.staticContext) {
                                routerProps.staticContext.status = 404;
                            }

                            return (
                                <Error404 {...this.props} {...routerProps} />
                            );
                        }}
                    />
                </Switch>
            </App>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/routes.jsx